import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { format, startOfMonth } from "date-fns";
import { getIndustriesData, getGoalData } from "../../api";

const initialState = {
  industriesData: [],
  industriesDataLoading: false,
  industriesError: null,
  goalData: null,
  goalDataLoading: false,
  goalError: null,
  filterDrawerOpen: false,
  filterData: {
    startDate: format(startOfMonth(new Date()), "MM/dd/yyyy"),
    endDate: format(new Date(), "MM/dd/yyyy"),
    payment_processors: [],
    cards: [],
  },
  filterUser: null,
  filterOrg: null,
  goalFilterKey: null,
  dailyGoalModalOpen: false,
};

const useDashboardStore = create(
  devtools((set) => ({
    ...initialState,
    setIndustriesData: (d) => set({ industriesData: d }),
    setIndustriesDataLoading: (d) => set({ industriesDataLoading: d }),
    setIndustriesError: (e) => set({ industriesError: e }),
    setGoalData: (d) => set({ goalData: d }),
    setGoalDataLoading: (d) => set({ goalDataLoading: d }),
    setGoalError: (e) => set({ goalError: e }),
    setFilterDrawerOpen: (d) => set({ filterDrawerOpen: d }),
    setDailyGoalModalOpen: (d) => set({ dailyGoalModalOpen: d }),
    setFilterData: (data) =>
      set((state) => ({
        filterData: {
          ...state.filterData,
          ...data,
        },
      })),
    setFilterUser: (d) => set({ filterUser: d }),
    setFilterOrg: (d) => set({ filterOrg: d }),
    setGoalFilterKey: (d) => set({ goalFilterKey: d }),
    getFilterCount: () => {
      let count = 0;
      if (useDashboardStore.getState().filterUser) count++;
      if (useDashboardStore.getState().filterOrg) count++;

      // add more for other filters
      return count;
    },
    reset: () => set(initialState),
  })),
);

export const fetchIndustriesData = async (abortController) => {
  useDashboardStore.setState({ industriesDataLoading: true });

  try {
    const res = await getIndustriesData(
      {
        start_date: useDashboardStore.getState().filterData.startDate,
        end_date: useDashboardStore.getState().filterData.endDate,
        user_id: useDashboardStore.getState().filterUser,
        org_id: useDashboardStore.getState().filterOrg,
      },
      abortController,
    );

    if (!res.status) {
      useDashboardStore.setState({
        industriesError: res?.message || "Error fetching industries data",
        industriesDataLoading: false,
      });
      return;
    }

    useDashboardStore.setState({
      industriesData: res.data,
      industriesDataLoading: false,
    });
  } catch (err) {
    if (err.name === "AbortError") {
      console.error(err);
      return;
    }
    useDashboardStore.setState({
      industriesError: err.message || "Error fetching industries data",
      industriesDataLoading: false,
    });
  }
};

export const fetchGoalData = async (
  data,
  abortController,
  setInitialLoading = true,
) => {
  // ToDo: Optimisic UI in a proper way, below is a temporary solution
  if (setInitialLoading) {
    useDashboardStore.setState({ goalDataLoading: true });
  }

  try {
    const res = await getGoalData(data, abortController);

    if (!res) {
      useDashboardStore.setState({
        goalError: "Error fetching goal data",
        goalDataLoading: false,
      });
      return;
    }

    useDashboardStore.setState({
      goalData: res,
      goalDataLoading: false,
      goalError: null,
    });
  } catch (err) {
    if (err.name === "AbortError") {
      return;
    }
    console.error("Goal data fetch error:", err);
    useDashboardStore.setState({
      goalError: err.message || "Error fetching goal data",
      goalDataLoading: false,
    });
  }
};

export default useDashboardStore;
